import { reactive, inject } from "vue";

export const stateSymbol = Symbol("ClienteState");

export const createState = () =>
  reactive({
    infos: {
      usarSms: false
    },
    whatsapp: false
  });

export const useState = () => inject(stateSymbol);
